import { useQuery } from '@tanstack/react-query';
import { useEffect, useMemo } from 'react';
import { findAdminMember, findCurrentUser } from '../utils/members';
import { initializeUpgradeStepData, UpgradeStepData } from '../api/upgradeToAdvanced';

export interface UseUpgradeStepDataOptions {
    onError?: () => void;
    initialData?: UpgradeStepData;
}

export const UPGRADE_DATA_KEY = 'upgrade_data_key';

export const useUpgradeStepData = ({ initialData, onError }: UseUpgradeStepDataOptions) => {
    const { isFetching, data, error } = useQuery({
        queryFn: initializeUpgradeStepData,
        queryKey: [UPGRADE_DATA_KEY],
        enabled: !initialData,
        initialData,
        refetchOnWindowFocus: false,
    });

    useEffect(() => {
        if (onError && error) {
            onError();
        }
    }, [error, onError]);

    const currentUser = useMemo(() => findCurrentUser(data?.members), [data?.members]);
    const isAdmin = currentUser?.role === 'admin';
    const organizationAdmin = useMemo(() => findAdminMember(data?.members), [data?.members]);

    return { isFetching, data, currentUser, isAdmin, organizationAdmin, error };
};
